import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch10_p01 } from "../../../layouts/ch10_p01/ch10_p01";

export class Chapter10Page1 extends AbstractStoryState implements ReturnType<typeof ch10_p01> {
    readonly bg = this.addChild(new SceneSprite());
    readonly characters = this.addChild(new SceneSprite());
    readonly confetti = list(()=>this.addChild(SceneSprite.withPrefix("ch10_p01/")));
    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch10_p01/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch10_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch10_p01.call(this);

        this.setChildIndex(this.frameLeft, this.getChildIndex(this.confetti[this.confetti.length-1]));
        this.setChildIndex(this.frameRight, this.getChildIndex(this.confetti[this.confetti.length-1]));

        this.bg.z = 10;
        this.characters.z = 9;
        for (let i=0; i<this.confetti.length; i++) {
            this.confetti[i].z = 8 - i;
        }

        this.makeParallax([
            this.bg,
            this.characters,
            ...this.confetti,
        ], {
            duration: 5,
            distance: 11,
            spread: 0.5,
            center: {x: 0.5, y: 0.5},
        });

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(5, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }
}